module.exports = __webpack_public_path__ + "static/media/Peter_Stephenson.2a42258a.jpg";